import React, { memo } from 'react'
import { SettingsModal } from './SettingsModal'
import { Navigate, Route, Routes } from 'react-router-dom'
import { EmailNotificationsSection } from './EmailNotificationsSection'
import { DeclineReasonsSection } from './DeclineReasonsSection'
import { PersonalAccessTokensSection } from './PersonalAccessTokensSection'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission, UserProductName } from 'src/constants/user'
import { ROUTES } from 'src/constants/routes'

const PersonalAccessTokensRoute = () => {
  const { hasPermission, hasProduct } = useCheckPermissions()

  if (!hasProduct(UserProductName.ApiIntegration) || !hasPermission(UserPermission.ApiKeysManage)) {
    return <Navigate to={ROUTES.SETTINGS_NOTIFICATIONS_URL} replace />
  }

  return <PersonalAccessTokensSection />
}

const SettingsComponent = () => {
  return (
    <Routes>
      <Route path="settings" element={<SettingsModal />}>
        <Route index element={<Navigate to="notifications" replace />} />
        <Route path="notifications" element={<EmailNotificationsSection />} />
        <Route path="decline-reasons" element={<DeclineReasonsSection />} />
        <Route path="personal-access-tokens" element={<PersonalAccessTokensRoute />} />
      </Route>
    </Routes>
  )
}

export const Settings = memo(SettingsComponent)
